module.exports = __webpack_public_path__ + "img/IMG_2808.6a365660.jpg";